export default "__VITE_ASSET__spfC37no__"